import { Badge, type BadgeTone } from './Badge';

export type Priority = 'Acil' | 'Yüksek' | 'Normal' | 'Düşük';

export interface PriorityPillProps {
  level: Priority | string;
}

const PRIORITY_MAP: Record<string, { tone: BadgeTone; dot: boolean }> = {
  'Acil':   { tone: 'danger', dot: true  },
  'Yüksek': { tone: 'warn',   dot: true  },
  'Normal': { tone: 'info',   dot: false },
  'Düşük':  { tone: 'slate',  dot: false },
};

export function PriorityPill({ level }: PriorityPillProps) {
  const { tone, dot } = PRIORITY_MAP[level] ?? { tone: 'neutral' as BadgeTone, dot: false };
  return <Badge tone={tone} dot={dot}>{level}</Badge>;
}
